import React from 'react';
import SortFilter from './SortFilter';
import { DateFilter } from './DateFilter';
import SortMode from './SortMode';
import ParliamentaryRecordMultipleHierarchy from './ParliamentaryRecordMultipleHierarchy';
import { OutsideCommonFilter, OutsideSearchFilter } from './OutsideFilters';
import SingleSelectFilter from 'components/Dashboard/Filters/ui/SingleSelectFilter';
import LastInteractionDateFilter from './LastInteractionDateFilter';
import TeammatesFilter from './TeammatesFilter';

const FilterTypeRenderer = ({
  type,
  allowedUsers,
  list,
  isExpandedOnAction,
  setExpanded,
  filterProps,
  showMoreOptions,
}) => {
  return (
    <>
      {type === 'search' && <OutsideSearchFilter {...filterProps} isExpanded={isExpandedOnAction} />}
      {type === 'sort' && <SortFilter {...filterProps} notIncludeName setExpanded={setExpanded} />}
      {type === 'date' && <DateFilter {...filterProps} notIncludeName notShowCalendar={!allowedUsers} />}
      {type === 'sortMode' && <SortMode {...filterProps} list={list} notIncludeName />}
      {type === 'singleSelect' && <SingleSelectFilter {...filterProps} notIncludeName />}
      {type === 'parliamentaryRecordMultipleHierarchy' && (
        <ParliamentaryRecordMultipleHierarchy {...filterProps} notIncludeName />
      )}
      {type === 'lastInteractionDate' && <LastInteractionDateFilter {...filterProps} />}
      {type === 'teammates' && <TeammatesFilter {...filterProps} idPrefix='outside-' />}
      {(!type || type === 'membership') && (
        <OutsideCommonFilter
          {...filterProps}
          isExpandedParent={isExpandedOnAction}
          allowedUsers={allowedUsers}
          showMoreOptions={showMoreOptions}
        />
      )}
    </>
  );
};

export default FilterTypeRenderer;
